

export const countries = [
  { name: "Afghanistan", value: "Afghanistan" },
  { name: "Albania", value: "Albania" },
  { name: "Algeria", value: "Algeria" },
  { name: "American Samoa", value: "American Samoa" },
  { name: "Andorra", value: "Andorra" },
  { name: "Angola", value: "Angola" },
  { name: "Anguilla", value: "Anguilla" },
  { name: "Antigua & Barbuda", value: "Antigua & Barbuda" },
  { name: "Argentina", value: "Argentina" },
  { name: "Armenia", value: "Armenia" },
  { name: "Aruba", value: "Aruba" },
  { name: "Australia", value: "Australia" },
  { name: "Austria", value: "Austria" },
  { name: "Azerbaijan", value: "Azerbaijan" },
  { name: "Azores", value: "Azores" },
  { name: "Bahamas", value: "Bahamas" },
  { name: "Bahrain", value: "Bahrain" },
  { name: "Bangladesh", value: "Bangladesh" },
  { name: "Barbados", value: "Barbados" },
  { name: "Belarus", value: "Belarus" },
  { name: "Belgium", value: "Belgium" },
  { name: "Belize", value: "Belize" },
  { name: "Benin", value: "Benin" },
  { name: "Bermuda", value: "Bermuda" },
  { name: "Bhutan", value: "Bhutan" },
  { name: "Bolivia", value: "Bolivia" },
  { name: "Bonaire", value: "Bonaire" },
  { name: "Bosnia & Herzegovina", value: "Bosnia & Herzegovina" },
  { name: "Botswana", value: "Botswana" },
  { name: "Brazil", value: "Brazil" },
  { name: "British Indian Ocean Ter", value: "British Indian Ocean Ter" },
  { name: "Brunei", value: "Brunei" },
  { name: "Bulgaria", value: "Bulgaria" },
  { name: "Burkina Faso", value: "Burkina Faso" },
  { name: "Burundi", value: "Burundi" },
  { name: "Cambodia", value: "Cambodia" },
  { name: "Cameroon", value: "Cameroon" },
  { name: "Canada", value: "Canada" },
  { name: "Canary Islands", value: "Canary Islands" },
  { name: "Cape Verde", value: "Cape Verde" },
  { name: "Cayman Islands", value: "Cayman Islands" },
  { name: "Central African Republic", value: "Central African Republic" },
  { name: "Chad", value: "Chad" },
  { name: "Channel Islands", value: "Channel Islands" },
  { name: "Chile", value: "Chile" },
  { name: "China", value: "China" },
  { name: "Christmas Island", value: "Christmas Island" },
  { name: "Cocos Island", value: "Cocos Island" },
  { name: "Colombia", value: "Colombia" },
  { name: "Comoros", value: "Comoros" },
  { name: "Congo Democratic Rep", value: "Congo Democratic Rep" },
  { name: "Congo", value: "Congo" },
  { name: "Cook Islands", value: "Cook Islands" },
  { name: "Costa Rica", value: "Costa Rica" },
  { name: "Cote D'Ivoire", value: "Cote D'Ivoire" },
  { name: "Croatia", value: "Croatia" },
  { name: "Cuba", value: "Cuba" },
  { name: "Curacao", value: "Curacao" },
  { name: "Cyprus", value: "Cyprus" },
  { name: "Czech Republic", value: "Czech Republic" },
  { name: "Denmark", value: "Denmark" },
  { name: "Djibouti", value: "Djibouti" },
  { name: "Dominica", value: "Dominica" },
  { name: "Dominican Republic", value: "Dominican Republic" },
  { name: "East Timor", value: "East Timor" },
  { name: "Ecuador", value: "Ecuador" },
  { name: "Egypt", value: "Egypt" },
  { name: "El Salvador", value: "El Salvador" },
  { name: "Equatorial Guinea", value: "Equatorial Guinea" },
  { name: "Eritrea", value: "Eritrea" },
  { name: "Estonia", value: "Estonia" },
  { name: "Ethiopia", value: "Ethiopia" },
  { name: "Falkland Islands", value: "Falkland Islands" },
  { name: "Faroe Islands", value: "Faroe Islands" },
  { name: "Fiji", value: "Fiji" },
  { name: "Finland", value: "Finland" },
  { name: "France", value: "France" },
  { name: "French Guiana", value: "French Guiana" },
  { name: "French Polynesia", value: "French Polynesia" },
  { name: "French Southern Ter", value: "French Southern Ter" },
  { name: "Gabon", value: "Gabon" },
  { name: "Gambia", value: "Gambia" },
  { name: "Georgia", value: "Georgia" },
  { name: "Germany", value: "Germany" },
  { name: "Ghana", value: "Ghana" },
  { name: "Gibraltar", value: "Gibraltar" },
  { name: "Great Britain", value: "Great Britain" },
  { name: "Greece", value: "Greece" },
  { name: "Greenland", value: "Greenland" },
  { name: "Grenada", value: "Grenada" },
  { name: "Guadeloupe", value: "Guadeloupe" },
  { name: "Guam", value: "Guam" },
  { name: "Guernsey", value: "Guernsey" },
  { name: "Guinea", value: "Guinea" },
  { name: "Guinea-Bissau", value: "Guinea-Bissau" },
  { name: "Guyana", value: "Guyana" },
  { name: "Haiti", value: "Haiti" },
  { name: "Honduras", value: "Honduras" },
  { name: "Hong Kong", value: "Hong Kong" },
  { name: "Hungary", value: "Hungary" },
  { name: "Iceland", value: "Iceland" },
  { name: "India", value: "India" },
  { name: "Indonesia", value: "Indonesia" },
  { name: "Iran", value: "Iran" },
  { name: "Iraq", value: "Iraq" },
  { name: "Isle of Man", value: "Isle of Man" },
  { name: "Israel", value: "Israel" },
  { name: "Italy", value: "Italy" },
  { name: "Jamaica", value: "Jamaica" },
  { name: "Japan", value: "Japan" },
  { name: "Jersey", value: "Jersey" },
  { name: "Jordan", value: "Jordan" },
  { name: "Kazakhstan", value: "Kazakhstan" },
  { name: "Kenya", value: "Kenya" },
  { name: "Kiribati", value: "Kiribati" },
  { name: "Korea North", value: "Korea North" },
  { name: "Korea South", value: "Korea South" },
  { name: "Kuwait", value: "Kuwait" },
  { name: "Kyrgyzstan", value: "Kyrgyzstan" },
  { name: "Laos", value: "Laos" },
  { name: "Latvia", value: "Latvia" },
  { name: "Lebanon", value: "Lebanon" },
  { name: "Lesotho", value: "Lesotho" },
  { name: "Liberia", value: "Liberia" },
  { name: "Libya", value: "Libya" },
  { name: "Liechtenstein", value: "Liechtenstein" },
  { name: "Lithuania", value: "Lithuania" },
  { name: "Luxembourg", value: "Luxembourg" },
  { name: "Macau", value: "Macau" },
  { name: "Macedonia", value: "Macedonia" },
  { name: "Madagascar", value: "Madagascar" },
  { name: "Malawi", value: "Malawi" },
  { name: "Malaysia", value: "Malaysia" },
  { name: "Maldives", value: "Maldives" },
  { name: "Mali", value: "Mali" },
  { name: "Malta", value: "Malta" },
  { name: "Marshall Islands", value: "Marshall Islands" },
  { name: "Martinique", value: "Martinique" },
  { name: "Mauritania", value: "Mauritania" },
  { name: "Mauritius", value: "Mauritius" },
  { name: "Mayotte", value: "Mayotte" },
  { name: "Mexico", value: "Mexico" },
  { name: "Midway Islands", value: "Midway Islands" },
  { name: "Moldova", value: "Moldova" },
  { name: "Monaco", value: "Monaco" },
  { name: "Mongolia", value: "Mongolia" },
  { name: "Montenegro", value: "Montenegro" },
  { name: "Montserrat", value: "Montserrat" },
  { name: "Morocco", value: "Morocco" },
  { name: "Mozambique", value: "Mozambique" },
  { name: "Myanmar", value: "Myanmar" },
  { name: "Namibia", value: "Namibia" },
  { name: "Nauru", value: "Nauru" },
  { name: "Nepal", value: "Nepal" },
  { name: "Netherland Antilles", value: "Netherland Antilles" },
  { name: "Netherlands", value: "Netherlands" },
  { name: "Nevis", value: "Nevis" },
  { name: "New Caledonia", value: "New Caledonia" },
  { name: "New Zealand", value: "New Zealand" },
  { name: "Nicaragua", value: "Nicaragua" },
  { name: "Niger", value: "Niger" },
  { name: "Nigeria", value: "Nigeria" },
  { name: "Niue", value: "Niue" },
  { name: "Norfolk Island", value: "Norfolk Island" },
  { name: "Norway", value: "Norway" },
  { name: "Oman", value: "Oman" },
  { name: "Pakistan", value: "Pakistan" },
  { name: "Palau Island", value: "Palau Island" },
  { name: "Palestine", value: "Palestine" },
  { name: "Panama", value: "Panama" },
  { name: "Papua New Guinea", value: "Papua New Guinea" },
  { name: "Paraguay", value: "Paraguay" },
  { name: "Peru", value: "Peru" },
  { name: "Philippines", value: "Philippines" },
  { name: "Pitcairn Island", value: "Pitcairn Island" },
  { name: "Poland", value: "Poland" },
  { name: "Portugal", value: "Portugal" },
  { name: "Puerto Rico", value: "Puerto Rico" },
  { name: "Qatar", value: "Qatar" },
  { name: "Reunion", value: "Reunion" },
  { name: "Romania", value: "Romania" },
  { name: "Russia", value: "Russia" },
  { name: "Rwanda", value: "Rwanda" },
  { name: "Saipan", value: "Saipan" },
  { name: "Samoa American", value: "Samoa American" },
  { name: "Samoa", value: "Samoa" },
  { name: "San Marino", value: "San Marino" },
  { name: "Sao Tome & Principe", value: "Sao Tome & Principe" },
  { name: "Saudi Arabia", value: "Saudi Arabia" },
  { name: "Senegal", value: "Senegal" },
  { name: "Serbia & Montenegro", value: "Serbia & Montenegro" },
  { name: "Serbia", value: "Serbia" },
  { name: "Seychelles", value: "Seychelles" },
  { name: "Sierra Leone", value: "Sierra Leone" },
  { name: "Singapore", value: "Singapore" },
  { name: "Slovakia", value: "Slovakia" },
  { name: "Slovenia", value: "Slovenia" },
  { name: "Solomon Islands", value: "Solomon Islands" },
  { name: "Somalia", value: "Somalia" },
  { name: "South Africa", value: "South Africa" },
  { name: "South Sudan", value: "South Sudan" },
  { name: "Spain", value: "Spain" },
  { name: "Sri Lanka", value: "Sri Lanka" },
  { name: "St Barthelemy", value: "St Barthelemy" },
  { name: "St Eustatius", value: "St Eustatius" },
  { name: "St Helena", value: "St Helena" },
  { name: "St Kitts-Nevis", value: "St Kitts-Nevis" },
  { name: "St Lucia", value: "St Lucia" },
  { name: "St Maarten", value: "St Maarten" },
  { name: "St Pierre & Miquelon", value: "St Pierre & Miquelon" },
  { name: "St Vincent & Grenadines", value: "St Vincent & Grenadines" },
  { name: "St Vincent & Grenadines" },
  { name: "Sudan", value: "Sudan" },
  { name: "Suriname", value: "Suriname" },
  { name: "Swaziland", value: "Swaziland" },
  { name: "Sweden", value: "Sweden" },
  { name: "Switzerland", value: "Switzerland" },
  { name: "Syria", value: "Syria" },
  { name: "Tahiti", value: "Tahiti" },
  { name: "Taiwan", value: "Taiwan" },
  { name: "Tajikistan", value: "Tajikistan" },
  { name: "Tanzania", value: "Tanzania" },
  { name: "Thailand", value: "Thailand"  },
  { name: "Togo", value: "Togo"  },
  { name: "Tokelau", value: "Tokelau" },
  { name: "Tonga", value: "Tonga" },
  { name: "Trinidad & Tobago", value: "Trinidad & Tobago" },
  { name: "Tunisia", value: "Tunisia" },
  { name: "Turkey", value: "Turkey" },
  { name: "Turkmenistan", value: "Turkmenistan" },
  { name: "Turks & Caicos Is", value: "Turks & Caicos Is" },
  { name: "Tuvalu", value: "Tuvalu" },
  { name: "Uganda", value: "Uganda" },
  { name: "Ukraine", value: "Ukraine" },
  { name: "United Arab Emirates", value: "United Arab Emirates" },
  { name: "United Kingdom", value: "United Kingdom" },
  { name: "United States of America", value: "United States of America" },
  { name: "Uruguay", value: "Uruguay" },
  { name: "Uzbekistan", value: "Uzbekistan" },
  { name: "Vanuatu", value: "Vanuatu" },
  { name: "Vatican City State", value: "Vatican City State" },
  { name: "Venezuela", value: "Venezuela" },
  { name: "Vietnam", value: "Vietnam" },
  { name: "Virgin Islands (USA)", value: "Virgin Islands (USA)" },
  { name: "Virgin Islands (Brit)", value: "Virgin Islands (Brit)" },
  { name: "Wake Island", value: "Wake Island" },
  { name: "Wallis & Futana Is", value: "Wallis & Futana Is" },
  { name: "Yemen", value: "Yemen" },
  { name: "Zambia", value: "Zambia" },
  { name: "Zimbabwe", value: "Zimbabwe"}
];

export const markets = [
  { value: "690360013", name: "Aviation" },
  { value: "690360001", name: "Construction" },
  { value: "690360002", name: " Data & Telecommunications" },
  { value: "690360003", name: " Defence & National Security" },
  { value: "690360014", name: " Education and Research" },
  { value: "690360004", name: " Energy" },
  { value: "690360005", name: " Government" },
  { value: "690360015", name: " Health" },
  { value: "690360007", name: " Manufacturing" },
  { value: "690360000", name: " Property" },
  { value: "690360009", name: " Resources" },
  { value: "690360010", name: " Transport" },
  { value: "690360011", name: " Water" },
  { value: "690360012", name: " Other" }
];


